const DEFAULT_PUBLIC_ASSET_BASE_URL = "https://lidere.md";

export const PUBLIC_ASSET_BASE_URL = (
    process.env.REACT_APP_PUBLIC_ASSET_BASE_URL ||
    process.env.REACT_APP_PUBLIC_IMAGE_BASE_URL ||
    DEFAULT_PUBLIC_ASSET_BASE_URL
).replace(/\/+$/, "");

const isAbsoluteUrl = (value = "") => /^https?:\/\//i.test(value);
const isWebpImage = (value = "") => /\.webp(?:$|\?)/i.test(value);

const normalizeWomanFilename = (filename = "") =>
    String(filename)
        .replace(/\\/g, "/")
        .replace(/^\/?images\/woman\//i, "")
        .replace(/^(thumb|large|original)\//i, "");

const normalizeNewsFilename = (filename = "") =>
    String(filename)
        .replace(/\\/g, "/")
        .replace(/^\/?images\/news\//i, "")
        .replace(/^(thumb|large|original)\//i, "");

const encodePath = (path = "") =>
    String(path)
        .split("/")
        .map((part) => encodeURIComponent(part).replace(/\(/g, "%28").replace(/\)/g, "%29"))
        .join("/");

export function getPublicAssetUrl(path) {
    if (!path) return "";
    if (isAbsoluteUrl(path)) return path;

    return `${PUBLIC_ASSET_BASE_URL}/${String(path).replace(/^\/+/, "")}`;
}

export function getWomanImageUrl(filename, variant = "large") {
    if (!filename) {
        return getPublicAssetUrl("/images/woman.png");
    }

    if (isAbsoluteUrl(filename)) {
        return filename;
    }

    const normalizedFilename = normalizeWomanFilename(filename);
    const normalizedVariant = variant === "thumb" ? "thumb" : "large";

    if (isWebpImage(normalizedFilename)) {
        return getPublicAssetUrl(`/images/woman/${normalizedVariant}/${encodePath(normalizedFilename)}`);
    }

    return getPublicAssetUrl(`/images/woman/${encodePath(normalizedFilename)}`);
}

export function getWomanThumbImageUrl(filename) {
    return getWomanImageUrl(filename, "thumb");
}

export function getWomanLargeImageUrl(filename) {
    return getWomanImageUrl(filename, "large");
}

export function getNewsImageUrl(path, variant = "large") {
    if (!path) {
        return getDefaultWomanImageUrl();
    }

    if (isAbsoluteUrl(path)) {
        return path;
    }

    const normalizedPath = String(path).replace(/\\/g, "/");

    if (/^\/?images\/(?!news\/)/i.test(normalizedPath)) {
        return getPublicAssetUrl(normalizedPath);
    }

    const normalizedFilename = normalizeNewsFilename(path);
    const normalizedVariant = variant === "thumb" ? "thumb" : "large";

    if (!normalizedFilename) {
        return getDefaultWomanImageUrl();
    }

    if (isWebpImage(normalizedFilename)) {
        return getPublicAssetUrl(`/images/news/${normalizedVariant}/${encodePath(normalizedFilename)}`);
    }

    return getPublicAssetUrl(`/images/news/${encodePath(normalizedFilename)}`);
}

export function getNewsThumbImageUrl(path) {
    return getNewsImageUrl(path, "thumb");
}

export function getNewsLargeImageUrl(path) {
    return getNewsImageUrl(path, "large");
}

export function getDefaultWomanImageUrl() {
    return getPublicAssetUrl("/images/woman.png");
}
